import React from 'react'
import { CardGridLayout } from '../../../lib/components'
import { CMSOpportunityDetailsRiskManagementType } from '../../../lib/types'
import { CMS_TEXT_BLOCK_CLASS } from './cms-section-text-content'

const CMSRiskManagement = ({
  riskManagement,
}: {
  riskManagement?: CMSOpportunityDetailsRiskManagementType
}) => {
  const riskImage = riskManagement?.riskManagementImage

  return (
    <CardGridLayout
      cardItems={riskManagement?.textItems}
      images={riskImage ? [riskImage] : undefined}
      layoutColumns={riskManagement?.layoutColumns ?? 1}
      dataTestId='cms-risk-management-content'
      textContentClassName={CMS_TEXT_BLOCK_CLASS}
    />
  )
}

export { CMSRiskManagement }
